export default "__VITE_ASSET__BoWI4JMj__"